export const OVERRIDDING_RISKFACTOR_LIST = 'src/components/RiskFactor/OverriddingRiskFactor/List/action/Overridding_RiskFactor_List';
export const OVERRIDDING_RISKFACTOR_LIST_SUCCESS = 'src/components/RiskFactor/OverriddingRiskFactor/List/action/Overridding_RiskFactor_List_Success';
export const OVERRIDDING_RISKFACTOR_LIST_FAILURE = 'src/components/RiskFactor/OverriddingRiskFactor/List/action/Overridding_RiskFactor_List_Failure';

export const overriddingRiskFactorList = () => {
    return {
        type: OVERRIDDING_RISKFACTOR_LIST,
    }
}
export const overriddingRiskFactorListSuccess = (data) => {
    return {
        type: OVERRIDDING_RISKFACTOR_LIST_SUCCESS,
        data
    }
}
export const overriddingRiskFactorListFailure = (data) => {
    return {
        type: OVERRIDDING_RISKFACTOR_LIST_FAILURE,
        data
    }
}